
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/advisory-board",
      function () {
        return require("private-next-pages/sa/advisory-board.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/advisory-board"])
      });
    }
  